import Text, { TextSize, TextVariant } from "@galaxy-io/dls/text/Text";
import { Link } from "@/app/navigation";
import { Stack } from "@/components/workspace/people-styles";

/**
 * An address this application has nothing at.
 *
 * Previously any unknown path rendered the signals board, so a stale link or a
 * typo looked like the app working — with the wrong address in the bar and no
 * hint that the page asked for does not exist. Saying so is shorter and kinder
 * than letting somebody wonder why their bookmark shows the wrong screen.
 */
export function NotFound({ pathname }: { pathname: string }) {
  return (
    <Stack padding={[48, 24]} maxWidth={544}>
      <Text size={TextSize.BODY_LG}>There is nothing at this address.</Text>
      <Text size={TextSize.BODY_SM} variant={TextVariant.SECONDARY}>
        {pathname} does not match any page here. It may have been renamed, or the link that brought
        you may be out of date.
      </Text>
      <Link href="/">
        <Text size={TextSize.BODY_SM}>Go to signals</Text>
      </Link>
    </Stack>
  );
}
